export default "__VITE_ASSET__a76e79f9__"